export const INSTAGRAM_OAUTH_MESSAGE_TYPE = 'oauth:instagram:result';

export type InstagramOAuthStatus = 'success' | 'error';

export type InstagramOAuthMessage = {
  type: typeof INSTAGRAM_OAUTH_MESSAGE_TYPE;
  status: InstagramOAuthStatus;
};

export const instagramOAuthMessage = (
  status: InstagramOAuthStatus
): InstagramOAuthMessage => ({
  type: INSTAGRAM_OAUTH_MESSAGE_TYPE,
  status,
});

export const isInstagramOAuthMessage = (
  data: unknown
): data is InstagramOAuthMessage => {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const message = data as Record<string, unknown>;

  return (
    message.type === INSTAGRAM_OAUTH_MESSAGE_TYPE &&
    (message.status === 'success' || message.status === 'error')
  );
};
